<template>
	<v-btn
			class="rounded"
			color="transparent"
			depressed
			fab
			small
			@click="editor.commands.redo()"
			@mousedown.stop.prevent
	>
		<v-icon>
			mdi-redo
		</v-icon>
	</v-btn>
</template>

<script>
export default {
	name: 'Redo',
	props: {
		editor: Object
	}
}
</script>

<style lang="scss" scoped>
.v-btn {
	transition-duration: 0.28s;
	transition-property: background-color, box-shadow, color, transform, opacity;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
</style>